module.exports = __webpack_public_path__ + "img/google.27df7f0f.png";